import { getStorage } from "store/local";
import proxy from "api/proxy";

export async function getUserWarehouse() {
  const session = getStorage("ctxSession");
  if (!session?.user) return null;

  const { data } = await proxy.search(
    "res.user",
    [["id", "=", session.user]],
    ["warehouse"],
    1,
  );

  const wh = data?.[0]?.warehouse;
  return wh?.id ?? wh ?? null;
}

const getType = () => {
  const options = [
    { id: "equipment", name: "Equipment" },
    { id: "instrument", name: "Instrument" },
    { id: "infrastructure", name: "infrastructure" },
    { id: "vehicle", name: "Vehicle" },
  ];

  return options;
};

function layoutMaintenance(config = {}) {
  const { warehouseId } = config;
  const ctxView = {
    model: "maintenance.equipment",
    form_action: ["edit", "add"],
    table_action: ["add", "edit"],
    activeSearch: true,
    domain: warehouseId ? [["warehouse", "=", warehouseId]] : [],
    fields: {
      model_num: { type: "char" },
      vin: { type: "char" },
      code: { type: "char" },
      gps_serial: { type: "char" },
      active: { type: "boolean" },
      serial: { type: "char" },
      type_device: { type: "selection", options: getType() },
      product: {
        type: "many2one",
        required: true,
        model: "product.template",
      },
      brand: {
        type: "many2one",
        model: "maintenance.equipment.brand",
      },
      party: { type: "many2one", model: "party.party" },
      kind: { type: "many2one", model: "maintenance.equipment.kind" },
    },
    list: [
      { name: "model_num" },
      { name: "product" },
      { name: "vin" },
      { name: "gps_serial" },
      { name: "serial" },
      { name: "active" },
      { name: "brand" },
      { name: "party" },
    ],
    form: [
      { name: "product" },
      { name: "party" },
      { name: "code" },
      { name: "vin" },
      { name: "active" },
      { name: "serial" },
      { name: "gps_serial" },
      { name: "brand" },
      { name: "model_num" },
      { name: "type_device" },
      {
        name: "block_checklist",
        type: "grid",
        colSpan: "col-span-2",
        elements: [{ name: "check_list" }],
      },
    ],
  };
  return ctxView;
}

export { layoutMaintenance };
